import React, { useState } from 'react';
import { FiMenu, FiSave } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';

const Settings = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('church');

  const [churchInfo, setChurchInfo] = useState({
    name: 'House of Praise',
    email: 'houseofpraise55@gmail.com',
    phone1: '+234 8125567466',
    phone2: '+234 8085516105',
    address: 'No 10 Sam Adeoye Idi mango, Aro lambo inside Matogun Road Oke-Aro Ogun State',
    officeHours: 'Friday: 9:00 AM - 5:00PM'
  });

  const [bankInfo, setBankInfo] = useState({
    accountNumber: '239 175 2787',
    bankName: 'Zenith Bank',
    accountName: 'James Hauwa'
  });

  const [serviceInfo, setServiceInfo] = useState({
    sundayService: 'Sunday Morning 8:00 AM',
    wednesdayService: 'Wednesday Evening 5:00 PM',
    smallGroups: 'Small Groups: Various Times'
  });

  const [socialMedia, setSocialMedia] = useState({
    facebook: 'https://facebook.com/houseofpraise',
    youtube: 'https://youtube.com/houseofpraise',
    instagram: 'https://instagram.com/houseofpraise'
  });

  const handleChurchInfoChange = (e) => {
    setChurchInfo({ ...churchInfo, [e.target.name]: e.target.value });
  };

  const handleBankInfoChange = (e) => {
    setBankInfo({ ...bankInfo, [e.target.name]: e.target.value });
  };

  const handleServiceInfoChange = (e) => {
    setServiceInfo({ ...serviceInfo, [e.target.name]: e.target.value });
  };

  const handleSocialMediaChange = (e) => {
    setSocialMedia({ ...socialMedia, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    alert('Settings saved successfully!');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} currentPage="settings" />

      <div className="lg:ml-64">
        <header className="bg-white shadow-sm">
          <div className="flex items-center justify-between p-4">
            <button onClick={() => setSidebarOpen(true)} className="lg:hidden">
              <FiMenu size={24} />
            </button>
            <h2 className="text-2xl font-bold text-gray-800">Settings</h2>
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-800">Admin User</p>
                <p className="text-xs text-gray-500">admin@houseofpraise.com</p>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-semibold">
                A
              </div>
            </div>
          </div>
        </header>

        <main className="p-6">
          {/* Tabs */}
          <div className="bg-white rounded-xl shadow-md mb-6">
            <div className="flex border-b border-gray-200 overflow-x-auto">
              <button
                onClick={() => setActiveTab('church')}
                className={`px-6 py-4 font-medium whitespace-nowrap ${
                  activeTab === 'church'
                    ? 'border-b-2 border-blue-600 text-blue-600'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                Church Info
              </button>
              <button
                onClick={() => setActiveTab('bank')}
                className={`px-6 py-4 font-medium whitespace-nowrap ${
                  activeTab === 'bank'
                    ? 'border-b-2 border-blue-600 text-blue-600'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                Bank Details
              </button>
              <button
                onClick={() => setActiveTab('service')}
                className={`px-6 py-4 font-medium whitespace-nowrap ${
                  activeTab === 'service'
                    ? 'border-b-2 border-blue-600 text-blue-600'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                Service Times
              </button>
              <button
                onClick={() => setActiveTab('social')}
                className={`px-6 py-4 font-medium whitespace-nowrap ${
                  activeTab === 'social'
                    ? 'border-b-2 border-blue-600 text-blue-600'
                    : 'text-gray-600 hover:text-gray-800'
                }`}
              >
                Social Media
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="bg-white rounded-xl shadow-md p-6">
            {/* Church Info Tab */}
            {activeTab === 'church' && (
              <div className="space-y-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Church Information</h3>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Church Name</label>
                  <input
                    type="text"
                    name="name"
                    value={churchInfo.name}
                    onChange={handleChurchInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={churchInfo.email}
                      onChange={handleChurchInfoChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone 1</label>
                    <input
                      type="tel"
                      name="phone1"
                      value={churchInfo.phone1}
                      onChange={handleChurchInfoChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone 2</label>
                  <input
                    type="tel"
                    name="phone2"
                    value={churchInfo.phone2}
                    onChange={handleChurchInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Address</label>
                  <textarea
                    name="address"
                    value={churchInfo.address}
                    onChange={handleChurchInfoChange}
                    rows="3"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Office Hours</label>
                  <input
                    type="text"
                    name="officeHours"
                    value={churchInfo.officeHours}
                    onChange={handleChurchInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            )}

            {/* Bank Details Tab */}
            {activeTab === 'bank' && (
              <div className="space-y-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Bank Account Details</h3>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Account Number</label>
                  <input
                    type="text"
                    name="accountNumber"
                    value={bankInfo.accountNumber}
                    onChange={handleBankInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Bank Name</label>
                  <input
                    type="text"
                    name="bankName"
                    value={bankInfo.bankName}
                    onChange={handleBankInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Account Name</label>
                  <input
                    type="text"
                    name="accountName"
                    value={bankInfo.accountName}
                    onChange={handleBankInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            )}

            {/* Service Times Tab */}
            {activeTab === 'service' && (
              <div className="space-y-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Service Times</h3>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Sunday Service</label>
                  <input
                    type="text"
                    name="sundayService"
                    value={serviceInfo.sundayService}
                    onChange={handleServiceInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Wednesday Service</label>
                  <input
                    type="text"
                    name="wednesdayService"
                    value={serviceInfo.wednesdayService}
                    onChange={handleServiceInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Small Groups</label>
                  <input
                    type="text"
                    name="smallGroups"
                    value={serviceInfo.smallGroups}
                    onChange={handleServiceInfoChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            )}

            {/* Social Media Tab */}
            {activeTab === 'social' && (
              <div className="space-y-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4">Social Media Links</h3>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Facebook</label>
                  <input
                    type="url"
                    name="facebook"
                    value={socialMedia.facebook}
                    onChange={handleSocialMediaChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder="https://facebook.com/..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">YouTube</label>
                  <input
                    type="url"
                    name="youtube"
                    value={socialMedia.youtube}
                    onChange={handleSocialMediaChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder="https://youtube.com/..."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Instagram</label>
                  <input
                    type="url"
                    name="instagram"
                    value={socialMedia.instagram}
                    onChange={handleSocialMediaChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder="https://instagram.com/..."
                  />
                </div>
              </div>
            )}

            {/* Save Button */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <button
                onClick={handleSave}
                className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition"
              >
                <FiSave size={20} />
                <span>Save Changes</span>
              </button>
            </div>
          </div>
        </main>
      </div>

      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default Settings;
